export default __webpack_public_path__ + "static/media/pixel-font.cb829af0.ttf";